import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a87da62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_input, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.order_no,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderState.searchOptions.order_no) = $event)),
      placeholder: "订单号",
      clearable: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_input, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.buyer_name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderState.searchOptions.buyer_name) = $event)),
      placeholder: "购车人",
      clearable: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_input, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.buyer_mobile_number,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderState.searchOptions.buyer_mobile_number) = $event)),
      maxlength: "11",
      placeholder: "购车人手机",
      clearable: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_input, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.seller_mobile_number,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderState.searchOptions.seller_mobile_number) = $event)),
      maxlength: "11",
      placeholder: "销售手机",
      clearable: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_select, {
      class: "search-item",
      size: "small",
      modelValue: _ctx.orderState.searchOptions.order_status,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderState.searchOptions.order_status) = $event)),
      clearable: "",
      placeholder: "订单状态（全部）"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderStatusOptions, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      size: "small",
      type: "primary",
      onClick: _ctx.handleSearchBtnClick
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      size: "small",
      color: "#fff",
      style: {"color":"#000","border":"1px solid #bfc5d9"},
      onClick: _ctx.handleResetSearchOptions
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}